import BranchSelector from "components/organism/BranchSelector";
import { rootPaths } from "pages/routes";
import React, { FC, useEffect } from "react";
import { Outlet } from "react-router";
import { Link } from "react-router-dom";
import { usePrefetchReviews } from "repository/useReviews";
import useUserData from "repository/useUser";
import useBID from "utils/useBid";
import SummaryCard from "./components/SummaryCard";
import Tabs from "./components/Tab";

const DashBoard: FC = () => {
  const bId = useBID();
  const prefetchReview = usePrefetchReviews(bId);
  const { data } = useUserData();

  useEffect(() => {
    prefetchReview();
  }, [prefetchReview]);

  return (
    <>
      <div className="is-flex is-align-items-center">
        <BranchSelector currentBID={bId} />
        {data?.isAdmin && (
          <Link to={"/" + rootPaths.admin}>
            <p className="ml-2">Admin画面へ</p>
          </Link>
        )}
      </div>
      <SummaryCard />
      <div className="card">
        <Tabs
          isSettingDisplay={
            data === undefined ||
            data.editableBranches.map((branch) => branch.bId).includes(bId)
          }
        />
        <div className="card-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default DashBoard;
